<section
  class="select-none"
  mat-dialog-title
>
  <span>Share Incident Rule</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>

<mat-dialog-content class="select-none">
  <avs-device-picker
    (selectedDevicesChange)="selectedDevices.set($event)"
    [apiFilters]="{ dataPoint: data.incidentRule.code }"
    [assignedDevices]="selectedDevices()"
    [itemTemplate]="deviceItemTpl"
    [masterDevice]="device()"
    scrollBlockHeight="300px"
    sessionFiltersId="share-incident-rule"
  />
  <ng-template
    #deviceItemTpl
    let-device
  >
    @if (devicesWithRule().has(device.id)) {
      <i
        class="icon-incidents-stroke text-ui---gray-1050 text-3xl"
        matTooltip="Rule already exists and will be overridden if selected"
      ></i>
    }
  </ng-template>

  @if (conflictingSelected().length) {
    <avs-message
      type="warning"
      class="mt-3"
    >
      Rule already exists and will be overridden.
      <button
        class="font-bold underline ml-auto"
        (click)="deselectConflicting()"
      >
        Deselect
      </button>
    </avs-message>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >
    Cancel
  </button>
  <button
    class="btn-green btn-medium font-bold"
    (click)="share()"
    [disabled]="isLoading() || !selectedDevices().length"
  >
    @if (isLoading()) {
      <mat-spinner
        class="mr-1"
        diameter="20"
      />
    }
    Share
  </button>
</mat-dialog-actions>
